var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{
      checked: _vm.isChecked,
      'table-disabled-checkbox': !_vm.status
    },attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }